import React from 'react'
import { useSelector } from 'react-redux'
import { Helmet } from 'react-helmet'
import { t } from 'ttag'

// import Account from 'components/pages/Account'
import Documents from 'components/pages/Documents'
import Help from 'components/pages/Help'
import { Home } from 'components/pages/Home/Home'
import Panel from 'components/pages/Panel/Panel'
import { Jobs } from 'components/pages/Jobs/Jobs'
import Preferences from 'components/pages/Preferences'
import { Templates } from 'components/pages/Templates/Templates'
import { Departments } from 'components/pages/Departments/Departments'
import { DashboardLayout } from '../layout/DashboardLayout/DashboardLayout'

import {
  getLocation,
  MODEL,
  PAGE,
  DASHBOARD,
  PANEL,
  TEMPLATES,
  DEPARTMENTS,
  PROJECTS,
} from 'ducks/router'
import { stringify } from 'utils/json'

const DashboardRoutes = () => {
  const { type, payload } = useSelector(getLocation)

  if (type === PAGE) {
    if (payload.page === 'training') return <Help />
    if (payload.page === 'config') return <Preferences />
    // if (payload.page === 'account') return <Account />
  }

  if (type === MODEL) {
    if (payload.model === 'documents') return <Documents />
  }

  if (type === PROJECTS) return <Jobs />
  if (type === TEMPLATES) return <Templates />
  if (type === DEPARTMENTS) return <Departments />
  if (type === DASHBOARD) return <Home />
  if (type === PANEL) return <Panel />

  return <p>{`unknown route ${stringify({ type, payload })}`}</p>
}

export const Dashboard = () => (
  <DashboardLayout>
    <Helmet>
      <title>{t`EBBER dashboard`}</title>
    </Helmet>
    <DashboardRoutes />
  </DashboardLayout>
)
